import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Approach from '../components/Approach';
import About from '../components/About';
import Services from '../components/Services';
import Methodology from '../components/Methodology';
import WhyChooseUs from '../components/WhyChooseUs';
import Industries from '../components/Industries';
import { Values, Journey, GlobalReach } from '../components/Values';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const Home = () => {
  useEffect(() => {
    document.title = 'Complise India | Regulatory Compliance & Market Access';
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.content = 'Complise India provides regulatory compliance, certification, licensing, testing coordination and market-access support for brands, importers and manufacturers.';
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-neutral-900">
      <Header />
      <main>
        <Hero />
        <Approach />
        <About />
        <Services />
        <Methodology />
        <WhyChooseUs />
        <Industries />
        <Values />
        <Journey />
        <GlobalReach />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
